// extracted by mini-css-extract-plugin
module.exports = {"main":"cities_main__uiSPD","citiesGroup":"cities_citiesGroup__4ZJbX"};